import { render, staticRenderFns } from "./WarehouseDetailCollections.vue?vue&type=template&id=532258e0&scoped=true&"
import script from "./WarehouseDetailCollections.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetailCollections.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseDetailCollections.vue?vue&type=style&index=0&id=532258e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532258e0",
  null
  
)

export default component.exports